import { HomeCarousel } from "../../components/carousel";
import { TopMenu } from "../../components/topmenu/TopMenu";
import { RightMenu } from "../../components/rightmenu/RightMenu";
import NewsView from "../news/NewsView";
import { DatasView } from "../datas/DatasView";
import { TechsView } from "../techs/TechsView";
import { Contact } from "../contact";

export function HomePage() {
  return (
    <div className="home">
      <TopMenu />
      <HomeCarousel id="home" />
      <NewsView id="news" />
      <DatasView id="datas" />
      <TechsView id="techs" />
      <Contact id="contact" />
      <RightMenu />
    </div>
  );
}
